import { useState } from 'react';
import './App.css';
import FaceImage from './headshot.jpg';

// Every link here points off-site, so open a new tab and cut the opener
// reference (rel=noopener) so the target page can't touch window.opener.
function A({ href, className, children }) {
  return (
    <a
      href={href}
      className={className}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
}

// Assembled at click time so the address never appears whole in markup.
const EMAIL_PARTS = ['weinbaumjonah', 'gmail', 'com'];

function Email() {
  const [copied, setCopied] = useState(false);

  async function copy() {
    const addr = `${EMAIL_PARTS[0]}@${EMAIL_PARTS[1]}.${EMAIL_PARTS[2]}`;
    try {
      await navigator.clipboard.writeText(addr);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.location.href = `mailto:${addr}`;
    }
  }

  return (
    <button
      className="link-item email-btn"
      onClick={copy}
      title="Copy email address"
    >
      {copied ? 'copied' : 'Email'}
    </button>
  );
}

const links = [
  { text: 'X', href: 'https://x.com/WeinbaumJonah' },
  { text: 'LinkedIn', href: 'https://www.linkedin.com/in/weinbaumjonah' },
  { text: 'GitHub', href: 'https://github.com/jonahwei19' },
];

function App() {
  return (
    <div className="page">
      <header className="masthead">
        <h1 className="name">Jonah Weinbaum</h1>
        <nav className="links" aria-label="Elsewhere">
          <Email />
          {links.map((l) => (
            <A className="link-item" key={l.href} href={l.href}>
              {l.text}
            </A>
          ))}
        </nav>
      </header>

      <main>
        <section className="intro">
          <img className="headshot" src={FaceImage} alt="Jonah Weinbaum" />
          <p>
            I work on AI at{' '}
            <A href="https://ifp.org/author/jonah">IFP</A>, doing a mix of{' '}
            <A href="https://www.youtube.com/watch?v=wkJU3ALEuMg">
              philanthropic-facing advising
            </A>{' '}
            and state capacity work.
          </p>
          <p>
            Before that I did independent work in AI. Before that I was CEO of{' '}
            <A href="https://jonahweinbaum.notion.site/Pink-Inference-Overview-720fc173d4c84413853a75628680462d">
              Pink Inference
            </A>
            , funded by <A href="https://www.1517fund.com/">1517</A> and{' '}
            <A href="https://www.mercatus.org/emergent-ventures">
              Emergent Ventures
            </A>
            , focused on wetware computing and later on building microelectrode arrays for a fraction of
competitors&rsquo; cost. After that I pivoted to compressed air
            energy storage and distributed energy resources at Capital Arc
            Energy.
          </p>
          <p>
            I studied math, physics, and cognitive science at the University of
            Michigan, and did research in theoretical CS and strategy. I ran a mini venture studio that built ALRT, an
            anti-sleep wearable, and{' '}
            <A href="https://www.michigandaily.com/news/campus-life/umich-students-launch-new-matchmaking-platform-called-unlonely-m/">
              Unlonely M
            </A>
            . I also did a bunch of other misc things, from{' '}
            <A href="https://www.businessinsider.com/living-hacker-house-completely-changed-career-trajectory-2024-10">
              hacker houses
            </A>{' '}
            to running 24-hour researchathons, being a venture fellow a few
            times, and doing some{' '}
            <A href="https://ui.adsabs.harvard.edu/abs/2023arXiv231210084P/abstract">
              quant
            </A>{' '}
            stuff.
          </p>
        </section>
      </main>
    </div>
  );
}

export default App;
